import { Injectable } from '@angular/core';
import algoliasearch from "algoliasearch";
import {LogService} from "./log.service";

@Injectable({
  providedIn: 'root'
})
export class AlgoliaService {
  config: any;
  indexName= 'VisitVar';
  searchClient = algoliasearch('8KXT844HAV', 'e2a51ef3ff82c832c11e17a6d9c410f1');
  constructor(private logService: LogService) {
    this.config = {
      indexName: this.indexName,
      searchClient : this.searchClient
    };
  }

  async search(textsearch : string) {
    const index = this.searchClient.initIndex(this.indexName);
    try {
      const { hits } = await index.search<any>(textsearch,{hitsPerPage:500});
      return hits;
    } catch (error: any) {
      this.logService.logAlgoliaError(error.toString());
    }
    return null;
  }
}
